import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { AuthService } from '../../../auth/auth.service';
import {csLegacyUrl} from "../../../constants";

const SIGNED_OUT_TITLE_KEY = 'app.signedOut.title';

@Component({
  selector: 'app-signed-out',
  templateUrl: './app-signed-out.component.html',
})
export class AppSignedOutComponent implements OnInit {
  public pageTitle = '';
  public csLegacyUrl = '';

  constructor(private translate: TranslateService,
              private authService: AuthService) { }

  public ngOnInit(): void {
    this.authService.logout();

    this.csLegacyUrl = csLegacyUrl;

    this.translate.get(SIGNED_OUT_TITLE_KEY).pipe(take(1)).subscribe(title => {
      this.pageTitle = title;
    });
  }
}
